/**
 * @property {number|null} start
 * @property {number|null} end
 */
export default class Range {
    constructor() {
        this.start = null;
        this.end = null;
    }

    /**
     * Returns a boolean indicating whether given `value` is included in this range.
     * @param {any} value
     * @return {boolean}
     */
    isIncluded(value) {
        value = parseInt(value);

        if (isNaN(value)) {
            throw new TypeError(`Range.isIncluded() method expects parameter 1 to be convertible to Integer, ${typeof value} (${value}) given`);
        }

        if (
            this.start === null
            && this.end === null
        ) {
            return true;
        }

        if (this.start !== null) {
            if (this.end !== null) {
                return (
                    value >= this.start
                    && value <= this.end
                );
            } else {
                return value >= this.start;
            }
        }

        // All cases involving `Range.start` property are covered

        if (this.end !== null) {
            return value <= this.end;
        }
    }

    /**
     * Returns a boolean indicating whether this range has any boundary.
     * @return {boolean}
     */
    isUnbound() {
        return this.start === null && this.end === null;
    }

    /**
     * Sets given `start` and given `end` as this date range new limits.
     * @param {any} start
     * @param {any} end
     * @return {Range}
     */
    set(start, end) {
        start = parseInt(start);

        if (isNaN(start)) {
            throw new TypeError(`Range.set() method expects parameter 1 to be convertible to Integer, ${typeof start} (${start}) given`);
        }

        end = parseInt(end);

        if (isNaN(end)) {
            throw new TypeError(`Range.set() method expects parameter 2 to be convertible to Integer, ${typeof end} (${end}) given`);
        }

        this.start = start;
        this.end = end;
        return this;
    }

    valueOf() {
        return [this.start, this.end];
    }
}
